<template>
<div>
    <base-header v-once pageName="나만의 플랜 등록" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="edu-myPlanReg">
            <p>설계한 신규 플랜을 저장합니다.<br/>
            플랜명을 입력하고, 저장 버튼을 클릭해 주세요.</p>
            <div>
                <input type="text" :value="planNm" v-on:input="planNm = $event.target.value" placeholder="플랜명을 입력해 주세요.">
                <em>{{titSize}}/10</em>
            </div>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="white" @click="submit('false')">취소</button>
        <button type="button" class="red" @click="submit('true')">등록</button>
    </div>
</div>
</template>

<script>
export default {
  name: "plan-regist",
  data() {
      return{
        titSize: 0,
		planNm: null,
        productList: [],
        from: '',
      };
  },
  watch: {
    planNm(newVal, oldVal){
        var len = newVal.length;

        if(len > 10)
            this.planNm = oldVal;
        else
            this.titSize = len;
    }
  },
  methods: {
      submit: function(boolean){        
        if(boolean == 'false'){
            this.$utils.nativeIf.outbound.close();
        }else{            
			if(!this.planNm || !this.planNm.trim()){
				alert("플랜명을 입력해주세요.");
				return false;
			}

            var parameters = {
                strSearchPrdt: JSON.stringify(this.productList),
                strMyPlanInfo: JSON.stringify({ 
                    planNm: this.planNm,
                })
            };

            var that = this;

            this.$api.eduplan.myPlanSave(parameters)
            .then(function(data) {
                if(data && data > 0){
                    alert("나만의 플랜 등록이 성공 하였습니다.");
                    var child = {
                        name: "eduplan_close_and_refresh",
                        data: { from : that.from}
                    };
                    that.$utils.nativeIf.outbound.sendChildData(child);     //이전 화면에 대한 처리
                }else{
                    alert("나만의 플랜 등록이 실패 하였습니다.");
                }
            })
            .catch(function(error) {
                    alert(error);
            });
        }
      }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
    if(parent.data.planReg) {
        this.productList = parent.data.planReg.list;
        this.from = parent.data.planReg.from;
    }
  }
};
</script>
